var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShoppingLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15 20C8.9 20 8.65 19.95 8.4 19.85C8.15 19.75 7.925 19.6 7.725 19.4L0.575 12.25C0.375 12.05 0.229167 11.8292 0.1375 11.5875C0.0458333 11.3458 0 11.1 0 10.85C0 10.6 0.0458333 10.35 0.1375 10.1C0.229167 9.85 0.375 9.625 0.575 9.425L9.375 0.6C9.55833 0.416667 9.775 0.270833 10.025 0.1625C10.275 0.0541667 10.5333 0 10.8 0H17.975C18.525 0 18.9958 0.195833 19.3875 0.5875C19.7792 0.979167 19.975 1.45 19.975 2V9.175C19.975 9.44167 19.925 9.69583 19.825 9.9375C19.725 10.1792 19.5833 10.3917 19.4 10.575L10.575 19.4C10.375 19.6 10.15 19.75 9.9 19.85C9.65 19.95 9.4 20 9.15 20ZM9.15 18L17.975 9.15V2H10.825L2 10.85L9.15 18ZM15.475 6C15.8917 6 16.2458 5.85417 16.5375 5.5625C16.8292 5.27083 16.975 4.91667 16.975 4.5C16.975 4.08333 16.8292 3.72917 16.5375 3.4375C16.2458 3.14583 15.8917 3 15.475 3C15.0583 3 14.7042 3.14583 14.4125 3.4375C14.1208 3.72917 13.975 4.08333 13.975 4.5C13.975 4.91667 14.1208 5.27083 14.4125 5.5625C14.7042 5.85417 15.0583 6 15.475 6Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingLabel);
export default __webpack_public_path__ + "static/media/shoppingLabel.68348c4980463ca4e3d9ff95d448b71a.svg";
export { ForwardRef as ReactComponent };